import React, {useCallback} from 'react';

import {BulkActionFooter} from 'src/components/bulk-tool/bulk-action-footer';

import Button from '@pb/kit-component-button';
import {DialogHeader, DialogMain} from '@pb/kit-component-dialog-v2';
import {Group} from '@pb/kit-component-group';
import {pluralize} from '@pb/kit-formatters';

import {TOOL_TITLE} from './constants';

import type {ProcessBulkAction} from 'src/components/bulk-tool/typedef';
import type {ActionOptions} from 'src/components/save-with-reason/action-with-reason-button';
import type {UsersRestore} from 'src/openapi/admin/models/UsersRestore';

type Props = {
    userIds: number[],
    conferenceAccountId: number,
    onCloseModal: (submit: boolean) => void,
    processAction: ProcessBulkAction<UsersRestore>,
};

export const RemoveAttendeesModal = ({userIds, conferenceAccountId, onCloseModal, processAction}: Props) => {
    const remove = useCallback(async (options?: ActionOptions) => {
        return await processAction({userIds, conferenceAccountId}, options);
    }, [userIds, conferenceAccountId, processAction]);

    return (
        <>
            <DialogHeader onClose={() => onCloseModal(false)}>
                {TOOL_TITLE}
            </DialogHeader>
            <DialogMain style={{padding: 24}}>
                Are you sure you want to remove {pluralize('user[s]', userIds.length)} from the conference?
            </DialogMain>
            <BulkActionFooter action="Remove" onConfirm={remove}>
                <Group>

                    <Button variant="Type.SECONDARY" onClick={() => onCloseModal(false)}>
                        Cancel
                    </Button>
                </Group>
            </BulkActionFooter>
        </>
    );
};
